import hres75uLabels from 'assets/labels/hres75u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres75uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        desc_codobf: faker.lorem.words(),
        desc_codunit: faker.lorem.word(),
        amtreq: faker.commerce.price(),
        amtwidrw: faker.commerce.price(),
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      codobf: faker.lorem.word(),
      desc_codobf: faker.lorem.word(),
      desc_typrelate: faker.lorem.word(),
      nameobf: faker.name.findName(),
      amtreq: faker.commerce.price(),
      desc_codunit: faker.lorem.word(),
      typpay: faker.lorem.word(),
      dtepay: moment().format('DD/MM/YYYY'),
      filenam1: faker.lorem.words(),
      filenam2: faker.lorem.words(),
      filenam3: faker.lorem.words(),
      desnote: faker.lorem.words()
    }
    let mockTab2Detail = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      codobf: faker.lorem.word(),
      desc_codobf: faker.name.findName()
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var i = 1; i <= mockTab2Total; i++) {
      mockTab2Rows.push({
        id: i,
        dtereq: moment().format('DD/MM/YYYY'),
        numvcher: faker.lorem.word(),
        amtwidrw: faker.commerce.price(),
        desc_codunit: faker.lorem.word(),
        desnote: faker.lorem.words()
      })
    }
    let mockTab3 = {
      codobf: faker.lorem.word(),
      desc_codobf: faker.lorem.words(),
      desc_codunit: faker.lorem.word(),
      syncond: faker.lorem.word(),
      desc_flglimit: faker.lorem.word(),
      desc_typrelate: faker.lorem.word(),
      dtestrt: moment().format('DD/MM/YYYY'),
      dteend: moment().format('DD/MM/YYYY'),
      amtwidrw: faker.commerce.price(),
      qtywidrw: faker.random.number().toString().substr(0, 1),
      acc_amt: faker.random.number().toString().substr(0, 1),
      acc_num: faker.random.number().toString().substr(0, 1),
      available: faker.commerce.price(),
      acc_all: faker.random.number().toString().substr(0, 1)
    }

    return {
      tab1: mockTab1,
      tab2: {
        detail: mockTab2Detail,
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      },
      tab3: mockTab3
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtwidrw: '',
      desc_codunit: faker.lorem.word(),
      dtepay: moment().format('DD/MM/YYYY'),
      numvcher: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      approvno: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtwidrw: faker.commerce.price(),
      desc_codunit: faker.finance.currencyName(),
      dtepay: moment().format('DD/MM/YYYY'),
      numvcher: faker.lorem.word(),
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres75u/mocker.js